

$(document).ready(function() {

	var $header = $('.header');
    var $headerSmall = $('.header');

    $header.elementDirectionAndOffsetByScroll('init', {
	    container : $(document),
        offsetSmall : ( 176 -72 ), // Best practice: header-height - header-small-height
		offsetOut : 176, // Best practice: header-height
        classInit : 'header--sticky-ready',
        classScrollDirectionDown : 'header--scroll-direction-down',
        classScrollDirectionUp : 'header--scroll-direction-up',
        classOffsetSmall: 'header--offset-small',
        classOffsetOut : 'header--offset-out',
        callbackScrollDirection : function (scrollDirection) {
            //console.log('scroll direction: ' + scrollDirection)
        },
        callbackOffsetSmall : function (scrollOffsetSmall) {
            //console.log('scrollOffsetSmall: ' + scrollOffsetSmall)
        }
    });

    // $('.header--no-sticky').elementDirectionAndOffsetByScroll('destroy');

});